import { SLIDERS_PATH } from './app';
import changeScreenSrc from './changeScreenSrc';

const changeActiveSlide = (swiper, page) => {
  const slider = swiper.el;
  const screen = slider.closest('section').querySelector('[data-screenshot]');
  const activeSlide = slider.querySelector('.swiper-slide-thumb-active');
  // console.warn(activeSlide);
  const activeSlideAdd = slider.querySelector('.swiper-slide-active');
  // console.warn(activeSlideAdd);

  const srcOptions = {
    path: SLIDERS_PATH,
    page: page,
    section: activeSlide?.dataset.section || activeSlideAdd?.dataset.section,
    index: activeSlide?.dataset.index || activeSlideAdd?.dataset.index,
  };

  changeScreenSrc(screen, srcOptions);
};

export default changeActiveSlide;
